/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */

export type HangarSyncOutcomeEnum = typeof HangarSyncOutcomeEnum[keyof typeof HangarSyncOutcomeEnum];


export const HangarSyncOutcomeEnum = {
  SYNCED: 'synced',
  NOTHING_TO_SYNC: 'nothing_to_sync',
  ONLY_SKIPPED_ITEMS: 'only_skipped_items',
} as const;
